export default {
    pathwayApiUrl: 'https://ep-app-Pathway-API-prod-nzn-dzhuajhteyhkexez.a03.azurefd.net',
    clientId: 'f6586cc3-e72a-4fa9-b2d6-7fbcbccdeb61',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 2,
    sampleRate: 0.5,
    sentry: {
        dsn: "https://42a88d7d380a850e92c6fc4d4cb5c143@o4509346579677184.ingest.de.sentry.io/4511701405925456",
    },
};
